<template>
  <card class="document-card margin-bottom-s" :custom-menu="isUploadedDocument" :has-content-padding="false">
    <div class="card-content flex-row align-center">
      <div class="document-left flex-row align-center">
        <div class="document-info flex-column margin-right-xxs">
          <div class="ri-body black-text">{{ documentTitle }}</div>
          <div class="flex-row align-center">
            <icon v-if="document.state === 'VERIFIED' || document.state === 'UPLOADED' || document.state === 'FAILED_VERIFICATION'"
                  :icon-name="statusIcon"
                  :size="'16px'"
                  :color="statusColor"
                  weight="bold"
            />
            <div v-if="documentComment" class="ri-label comment margin-right-xxs" :class="{ verified: document.state === 'VERIFIED',
          uploaded: document.state === 'UPLOADED', 'failed': document.state === 'FAILED_VERIFICATION' }">
              {{ documentComment }}
            </div>
          </div>
        </div>
      </div>

      <div  v-if="document.state === 'REQUIRED' || document.state === 'FAILED_VERIFICATION'"
            class="document-actions flex-row align-center margin-right-auto">
        <template>
          <icon
              icon-name="add"
              :size="'20px'"
              :color="Colors.riseupBlue"
              class="document-add-icon"
              @click="$emit('upload', document)"
          />
        </template>
      </div>
      <template v-if="document.state === 'UPLOADED' || document.state === 'VERIFIED'">
        <bottom-sheet-overflow-button
            :bottom-sheet-component="menuComponent"
            :component-props="menuComponentProps"
        />
      </template>
    </div>
  </card>
</template>

<script>
import moment from 'moment';
import BaseUI from '@riseupil/base-ui';
import BottomSheetOverflowButton from '@/base-components/BottomSheetOverflowButton';
import DocumentMenu from './DocumentMenu.vue';

const DOCUMENT_TYPE_LABELS = {
  PAYCHECK: 'תלוש משכורת',
  TAX_RETURN: 'דוח מס',
  BANK_STATEMENT: 'אישור מס',
  PROPERTY_APPRAISAL: 'שומה של הנכס',
  PURCHASE_AGREEMENT: 'הסכם רכישה',
  ID_CARD: 'תעודת זהות',
  OTHER: 'אחר',
};

export default {
  name: 'DocumentCard',
  components: {
    Card: BaseUI.Card,
    Icon: BaseUI.Icon,
    BottomSheetOverflowButton,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Colors: BaseUI.Colors,
      menuComponent: DocumentMenu,
    };
  },
  computed: {
    documentTitle() {
      return DOCUMENT_TYPE_LABELS[this.document.documentType] || this.document.documentType;
    },
    documentComment() {
      if (this.document.state === 'FAILED_VERIFICATION') {
        return 'המסמך לא תקין, כדאי לנסות שוב';
      }
      if (this.document.state === 'UPLOADED') {
        return 'אנחנו בודקים את המסמך, תכף נעדכן';
      }
      if (this.document.state === 'VERIFIED') {
        return `העלית את המסמך ב- ${this.formatDate(this.document.updatedAt)}`;
      }
      return '';
    },
    isUploadedDocument() {
      return this.document.state !== 'REQUIRED';
    },
    statusIcon() {
      if (this.document.state === 'VERIFIED') { return 'check'; }
      if (this.document.state === 'UPLOADED') { return 'schedule'; }
      return 'replay';
    },
    statusColor() {
      if (this.document.state === 'VERIFIED') { return BaseUI.Colors.riseupGreen; }
      if (this.document.state === 'UPLOADED') { return BaseUI.Colors.riseupBlue; }
      return BaseUI.Colors.riseupDangerRed;
    },
    menuComponentProps() {
      return {
        menuItems: [
          {
            text: 'להחליף קובץ',
            iconProps: {
              iconName: 'upload',
              fill: true,
            },
            onClick: this.handleChangeFile,
          },
          {
            text: 'להוריד',
            iconProps: {
              iconName: 'download',
              fill: true,
            },
            onClick: this.handleDownload,
          },
        ],
      };
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    handleChangeFile() {
      this.$emit('upload', this.document);
    },
    handleDownload() {
      this.$emit('download', this.document);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.document-card {
  height: 70px;
  background-color: $riseup_white;
  border-radius: 20px;
  padding: 8px 12px;

  .document-add-icon {
    border-radius: 50%;
    margin-left: 8px;
    height: 34px;
    width: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $riseup_light_blue;

    &:hover {
      cursor: pointer;
    }
  }

  .card-content {
    width: 100%;
    height: 100%;
  }

  .document-left {
    text-align: right;
    flex: 1;
    height: 44px;
  }

  .document-info {
    flex: 1;
    text-align: right;
  }

  .comment.uploaded {
    color: $riseup_blue;
  }
  .comment.failed {
    color: $riseup_danger_red;
  }
  .comment.verified {
    color: $riseup_gray_2;
  }
}
</style>
